export const baseApiUrl = 'https://app-api.copilot-staging.com/';
/**
 * This is a custom HoC that returns
 * the api endpoint url based on the
 * api path/name.
 * @param path: api name (e.g. companies)
 * @returns full endpoint url
 */
export const getApiEndpointUrl = (path: string) =>
  new URL(path, baseApiUrl).toString();
